import qs from 'query-string'
import store from '../../store'
import * as mutations from './store/mutation-types'
import {get_html_from_element} from './components/editor/editor_utils'
import emojis from './components/emoji-picker/emojis.json'
import axios from "axios"

const slack_api_axios_instance = axios.create({
    baseURL: 'https://slack.com/api/',
    timeout: 4000,
})
slack_api_axios_instance.interceptors.response.use(
    response => {
        if (response.data && !response.data.ok && ['invalid_auth', 'missing_scope', 'token_expired', 'token_revoked'].includes(response.data.error)) {
            if (localStorage.getItem('SLACK_SESSION')) {
                localStorage.removeItem('SLACK_SESSION')
            }
            store.commit(mutations.SLACK_SET_IS_SIGNED_IN, false)
        }
        return response
    }, error => Promise.reject(error)
)

export function init() {
    const slack_session = JSON.parse(localStorage.getItem('SLACK_SESSION'))
    store.commit(mutations.SLACK_SET_IS_SIGNED_IN, !!slack_session && slack_session.is_signed_in)
}

export async function create_channel({name, is_private}) {
    const session = get_session()
    if (!session) {
        return Promise.reject()
    }
    const headers = {
            'Content-Type': 'application/x-www-form-urlencoded',
        },
        data = {
            token: session.access_token,
        },
        params = {
            name,
            is_private,
        },
        url = 'conversations.create',
        response = await slack_api_axios_instance.post(url, qs.stringify(data), {headers, params})
    if (response.data) {
        return response.data
    }
    return response
}

export async function delete_message(channel, ts) {
    const session = get_session()
    if (!session) {
        return Promise.reject()
    }
    const headers = {
            'Content-Type': 'application/x-www-form-urlencoded',
        },
        data = {
            token: session.access_token,
        },
        params = {
            as_user: true,
            channel,
            ts,
        },
        url = 'chat.delete',
        response = await slack_api_axios_instance.post(url, qs.stringify(data), {headers, params})
    if (response.data) {
        return response.data
    }
    return response
}

export async function fetch_saved_items(params) {
    const session = get_session()
    if (!session) {
        return Promise.reject()
    }
    const headers = {
            'Content-Type': 'application/x-www-form-urlencoded',
        },
        data = {
            token: session.access_token,
        },
        url = 'stars.list',
        response = await slack_api_axios_instance.post(url, qs.stringify(data), {headers, params})
    if (response.data) {
        const items = []
        for (let index = 0; index < response.data.items.length; index++) {
            const item = response.data.items[index]
                , {message} = item
            if (item.type === 'message') {
                const user = await get_user_info(message.user)
                if (user) {
                    message.name = user.real_name
                    message.user_info = user
                }
                items.push(item)
            }
        }
        response.data.items = items
        return response.data
    }
    return response
}

export async function get_user_info(user) {
    const session = get_session()
    if (!session) {
        return Promise.reject()
    }
    const users = store.getters.slack_users_object
    if (users[user]) {
        return Promise.resolve(users[user])
    }
    const headers = {
            'Content-Type': 'application/x-www-form-urlencoded',
        },
        data = {
            token: session.access_token,
        },
        params = {
            user,
        },
        url = 'users.info',
        response = await slack_api_axios_instance.post(url, qs.stringify(data), {headers, params})
    if (response.data.user) {
        store.commit(mutations.SLACK_SET_USER, response.data.user)
        return response.data.user
    }
    return false
}

export async function list_channels() {
    const session = get_session()
    if (!session) {
        return Promise.reject()
    }
    const headers = {
            'Content-Type': 'application/x-www-form-urlencoded',
        },
        data = {
            token: session.access_token,
        },
        params = {
            types: 'public_channel,im',
        },
        url = 'users.conversations',
        response = await slack_api_axios_instance.post(url, qs.stringify(data), {headers, params})
    if (response.data.channels) {
        const channels = [],
            ims = []
        for (let index = 0; index < response.data.channels.length; index++) {
            const ch = response.data.channels[index]
            if (ch.is_channel) {
                channels.push(ch)
            } else if (ch.is_im) {
                const user = await get_user_info(ch.user)
                if (user) {
                    ch.name = user.real_name
                    ch.user_info = user
                }
                ims.push(ch)
            }
        }
        store.commit(mutations.SLACK_SET_CHANNELS, response.data.channels)
        return {
            channels,
            ims,
        }
    }
    return {}
}

export async function list_conversation(channel, opt = {}) {
    const session = get_session()
    if (!session) {
        return Promise.reject()
    }
    const headers = {
            'Content-Type': 'application/x-www-form-urlencoded',
        },
        data = {
            token: session.access_token,
        },
        params = {
            channel,
            ...opt,
        },
        url = 'conversations.history',
        response = await slack_api_axios_instance.post(url, qs.stringify(data), {headers, params})
    if (response.data.messages) {
        for (let index = 0; index < response.data.messages.length; index++) {
            const msg = response.data.messages[index]
            if (msg.user) {
                msg.user_info = await get_user_info(msg.user)
            }
        }
        return response.data
    }
    return {messages: []}
}

export async function list_replies(channel, ts, opt = {}) {
    const session = get_session()
    if (!session) {
        return Promise.reject()
    }
    const headers = {
            'Content-Type': 'application/x-www-form-urlencoded',
        },
        data = {
            token: session.access_token,
        },
        params = {
            channel,
            ts,
            ...opt,
        },
        url = 'conversations.replies',
        response = await slack_api_axios_instance.post(url, qs.stringify(data), {headers, params})
    if (response.data.messages) {
        for (let index = 0; index < response.data.messages.length; index++) {
            const msg = response.data.messages[index]
            if (msg.user) {
                msg.user_info = await get_user_info(msg.user)
            }
        }
        return response.data
    }
    return {messages: []}
}

export async function list_users() {
    const session = get_session()
    if (!session) {
        return Promise.reject()
    }
    const headers = {
            'Content-Type': 'application/x-www-form-urlencoded',
        },
        data = {
            token: session.access_token,
        },
        params = {
            limit: 500,
        },
        url = 'users.list',
        response = await slack_api_axios_instance.post(url, qs.stringify(data), {headers, params})
    if (response.data.members) {
        store.commit(mutations.SLACK_SET_USERS, response.data.members)
        return response.data.members
    }
    return []
}

export async function pin(timestamp, channel, pin = true) {
    const session = get_session()
    if (!session) {
        return Promise.reject()
    }
    const headers = {
            'Content-Type': 'application/x-www-form-urlencoded',
        },
        data = {
            token: session.access_token,
        },
        params = {
            channel,
            timestamp,
        },
        url = pin ? 'pins.add' : 'pins.remove',
        response = await slack_api_axios_instance.post(url, qs.stringify(data), {headers, params})
    if (response.data) {
        return response.data
    }
    return response
}

export async function post_message(message) {
    const session = get_session()
    if (!session) {
        return Promise.reject()
    }
    const data = {
            ...message,
            token: session.access_token,
        },
        method = 'chat.postMessage',
        params = {
            method,
            data,
        },
        response = await axios.post(`/api/slack/doAction`, params)
    if (response && response.data && response.data.ok) {
        response.data.message.user_info = await get_user_info(response.data.message.user)
        return response.data
    }
    return Promise.reject()
}

export async function post_file(file_info, channel) {
    const session = get_session()
    if (!session) {
        return Promise.reject()
    }

    let response = ""

    // console.log(file_info[1].files[0])

    const reader = new FileReader();
    reader.readAsDataURL(file_info[1].files[0]);

     reader.addEventListener("load", async () => {
         // convert image file to base64 string
         const data = {
             channel: channel,
             message: file_info[0].value,
             file: file_info[1].files[0].name,
             file_content: reader.result,
             token: session.access_token,
         }
         const method = 'files.upload'
         const params = {
             method,
             data,
         }
         response = await axios.post(`/api/slack/sendFile`, params)

     })

    return response;
}

export async function reactions(name, timestamp, channel, type = 'add') {
    const session = get_session()
    if (!session) {
        return Promise.reject()
    }
    const headers = {
            'Content-Type': 'application/x-www-form-urlencoded',
        },
        data = {
            token: session.access_token,
        },
        params = {
            channel,
            name,
            timestamp,
        },
        url = `reactions.${type}`,
        response = await slack_api_axios_instance.post(url, qs.stringify(data), {headers, params})
    if (response.data) {
        return response.data
    }
    return response
}

export async function reactions_add(name, timestamp, channel) {
    return reactions(name, timestamp, channel, 'add')
}

export async function star(timestamp, channel, add = true) {
    const session = get_session()
    if (!session) {
        return Promise.reject()
    }
    const headers = {
            'Content-Type': 'application/x-www-form-urlencoded',
        },
        data = {
            token: session.access_token,
        },
        params = {
            channel,
            timestamp,
        },
        url = `stars.${add ? 'add' : 'remove'}`,
        response = await slack_api_axios_instance.post(url, qs.stringify(data), {headers, params})
    if (response.data) {
        return response.data
    }
    return response
}

export async function unpin(ts, channel) {
    return pin(ts, channel, false)
}

export async function unstar(ts, channel) {
    return star(ts, channel, false)
}

export function get_message(message) {
    let msg = ''
    if (message.blocks) {
        message.blocks.forEach(b => {
            if (b.type === 'rich_text') {
                b.elements.forEach(element => {
                    if (element.type === 'rich_text_section') {
                        element.elements.forEach(e => {
                            switch (e.type) {
                                case 'emoji':
                                    const data = {}
                                    data.id = e.name
                                    data.skin_tone = 'default'
                                    if (e.skin_tone) {
                                        data.skin_tone = `skin-tone-${e.skin_tone}`
                                    }
                                    data.emoji = emojis.reduce((_, group) => (_ || group.emojis.find(emoji => emoji.id === e.name)), null)
                                    const wrapper = document.createElement('div')
                                        , emoji = document.createElement('span')
                                        , emoji_content = document.createElement('img')
                                    emoji.classList.add('c-emoji', 'c-emoji__medium', 'c-emoji--inline')
                                    emoji.setAttribute('contenteditable', false)
                                    emoji.setAttribute('data-id', data.name)
                                    if (data.skin_tone !== 'default') {
                                        emoji.setAttribute('data-skin-tone', data.skin_tone.replace('skin-tone-', ''))
                                    }
                                    emoji_content.setAttribute('src', data.emoji[data.skin_tone])
                                    emoji.append(' ')
                                    emoji.append(emoji_content)
                                    emoji.append(' ')
                                    wrapper.append(emoji)
                                    msg += wrapper.innerHTML
                                    break
                                case 'text':
                                    msg += get_html_from_element(e)
                                    break
                                case 'user':
                                    const user = store.getters.slack_users_object[e.user_id]
                                    user && (msg += `<span class="slack-mention" data-id="${user.id}">${user.real_name}</span>`)
                                    break
                            }
                        })
                    }
                })
            }
        })
        return msg
    }
    return message.text
}

export function get_msg_time(message) {
    const {ts} = message, dateString = ts.split('.')[0]
    return moment(parseInt(dateString) * 1000).format('hh:mm A')
}

export function is_me(user_id) {
    const session = get_session()
    return session && session.data && session.data.sub === user_id
}

export function is_pinned(message, channel = null) {
    if (!!channel) {
        return !!message.pinned_info && message.pinned_info.channel === channel
    }
    return !!message.pinned_info
}

export function login() {
    const session = JSON.parse(localStorage.getItem('SLACK_SESSION'))
    if (session && session.data && session.data.sub) {
        session.is_signed_in = true
        localStorage.setItem('SLACK_SESSION', JSON.stringify(session))
        store.commit(mutations.SLACK_SET_IS_SIGNED_IN, true)
        return Promise.resolve()
    }
    const {
            SLACK_CLIENT_ID,
        } = Laravel.env.SLACK,
        slack_url = 'https://slack.com/oauth/v2/authorize',
        redirect_uri = `${window.location.origin}/slack`,
        params = {
            client_id: SLACK_CLIENT_ID,
            redirect_uri,
            response_type: 'code',
            user_scope: 'chat:write,channels:history,channels:read,channels:write,emoji:read,files:write,files:read,groups:write,im:history,im:read,im:write,mpim:write,reactions:read,reactions:write,stars:write,users:read,users:read.email',
        },
        h = 560,
        w = 705,
        left = (screen.width / 2) - (w / 2),
        top = (screen.height / 2) - (h / 2),
        query_string = qs.stringify(params),
        url = `${slack_url}?${query_string}`,
        slack_window = window.open(url, '_blank', `left=${left},location=yes,height=${h},top=${top},width=${w}`)
    return new Promise((resolve, reject) => {
        const interval = setInterval(() => {
            try {
                const {pathname} = slack_window.location
                if (pathname && pathname !== 'blank') {
                    clearInterval(interval)
                    slack_window.close()
                    const href = slack_window.location.href,
                        code_object = {...qs.parse(href)},
                        code = Object.values(code_object)[0],
                        params = {code, redirect_uri}
                    axios.post(`/api/slack/loginWithCode`, params)
                        .then(res => {
                            const {data} = res.data
                            if (data) {
                                data.is_signed_in = true
                                data.data = parseJwt(data.id_token)
                                localStorage.setItem('SLACK_SESSION', JSON.stringify(data))
                                store.commit(mutations.SLACK_SET_IS_SIGNED_IN, true)
                            }
                            return res
                        })

                    resolve()
                }
            } catch (error) {
                console.log(error)
            }
        }, 300)
    })
}

export async function logout() {
    const session = JSON.parse(localStorage.getItem('SLACK_SESSION'))
    if (session) {
        session.is_signed_in = false
        localStorage.setItem('SLACK_SESSION', JSON.stringify(session))
    }
    store.commit(mutations.SLACK_SET_IS_SIGNED_IN, false)
    return Promise.resolve({ok: true})
}

async function revoke_token() {
    const session = get_session()
    if (!session) {
        return Promise.reject()
    }
    const headers = {
            'Content-Type': 'application/x-www-form-urlencoded',
        },
        data = {
            token: session.access_token,
        },
        url = 'auth.revoke',
        response = await slack_api_axios_instance.post(url, qs.stringify(data), {headers})
    if (response.data.members) {
        store.commit(mutations.SLACK_SET_USERS, response.data.members)
        return response.data.members
    }
    return []
}

function get_session() {
    return JSON.parse(localStorage.getItem('SLACK_SESSION'))
}

function parseJwt(token) {
    var base64Url = token.split('.')[1];
    var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    var jsonPayload = decodeURIComponent(atob(base64).split('').map(function (c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));

    return JSON.parse(jsonPayload);
}

export function get_frequently_used_emojis() {
    const session = get_session()
    if (session) {
        return session.frequently_used_emojis
    }
}

export function set_frequently_used_emojis(data) {
    const session = get_session()
    if (session) {
        session.frequently_used_emojis = data
        localStorage.setItem('SLACK_SESSION', JSON.stringify(session))
    }
}
